import { CommonModule, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatProgressBarModule, MatSnackBarModule } from '@angular/material';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { EditorModule } from '@tinymce/tinymce-angular';
import { FileUploadModule } from 'ng2-file-upload';
import { QuillModule } from 'ngx-quill';
import { AppConfigService } from './app-config.service';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AutoLockAccessDeniedComponent } from './auto-lock-access-denied/auto-lock-access-denied.component';
import { AutoLockAccessComponent } from './auto-lock-access/auto-lock-access.component';
import { NewlinePipe } from './common/pipes/newline.pipe';
import { SafeHtmlPipe } from './common/pipes/safe-html.pipe';
import { TimerPipe } from './common/pipes/timer.pipe';
import { DITimeRemainingComponent } from './di-time-remaining/di-time-remaining.component';
import { DIViewsRemainingComponent } from './di-views-remaining/di-views-remaining.component';
import { DisappearInkComponent } from './disappear-ink/disappear-ink.component';
import { EmailVerificationComponent } from './email-verification/email-verification.component';
import { EncryptDisappearInkComponent } from './encrypt-disappear-ink/encrypt-disappear-ink.component';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { PasscodeverifyComponent } from './passcodeverify/passcodeverify.component';
import { ProtectedReplyComponent } from './protected-reply/protected-reply.component';
import { ProtectedTextComponent } from './protected-text/protected-text.component';
import { RedactNewComponent } from './redact-new/redact-new.component';
import { SendertextViewComponent } from './sendertext-view/sendertext-view.component';
import { TextViewComponent } from './text-view/text-view.component';
import { TextViewv1Component } from './text-viewv1/text-viewv1.component';
import { TimeRemainingComponent } from './time-remaining/time-remaining.component';
import { ViewsRemainingComponent } from './views-remaining/views-remaining.component';
import { SkeletonLoaderComponent } from './shared/skeleton-loader/skeleton-loader.component';
import { TransactionTerminatedComponent } from './transaction-terminated/transaction-terminated.component';
export function HttpLoaderFactory(http: HttpClient) {
return new TranslateHttpLoader(http, '../assets/i18n/', '.json');

}
@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    NewlinePipe,
    FooterComponent,
    TimerPipe,
   TextViewComponent,
    SendertextViewComponent,
    TimeRemainingComponent,
    ViewsRemainingComponent,
    DisappearInkComponent,
    EncryptDisappearInkComponent,
    SafeHtmlPipe,
    RedactNewComponent,
    DITimeRemainingComponent,
    DIViewsRemainingComponent,
    EmailVerificationComponent,
    AutoLockAccessDeniedComponent,
    AutoLockAccessComponent,
    ProtectedTextComponent,
    PasscodeverifyComponent,
    ProtectedReplyComponent,
    SkeletonLoaderComponent,
    TextViewv1Component,
     TransactionTerminatedComponent
    // HttpClientModule,
  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    CommonModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    EditorModule,
    NgSelectModule,
    FileUploadModule,
    MatSnackBarModule,
    MatProgressBarModule,
    QuillModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })

  ],
  providers: [AppConfigService,
    Location,
    { provide: LocationStrategy, useClass: PathLocationStrategy }
    // { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
